import { ApiAddress } from "config";

export async function sendMessage(message, chatId, image) {
    return (await fetch(ApiAddress + "/send_message", {
        body: JSON.stringify({ message, chatId, image }),
        method: "post",
        headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.auth }
    })).json();
}